module.exports = __webpack_public_path__ + "img/ewm_02.a64ab3d6.jpg";